import { render, staticRenderFns } from "./HandOffTable.vue?vue&type=template&id=62982c41&scoped=true"
import script from "./HandOffTable.vue?vue&type=script&lang=js"
export * from "./HandOffTable.vue?vue&type=script&lang=js"
import style0 from "./HandOffTable.vue?vue&type=style&index=0&id=62982c41&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62982c41",
  null
  
)

export default component.exports